import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

export const ConstrainedContent = styled.div`
	max-width: 480px;

	${mobileMediaQuery(css`
		max-width: unset;
	`)}
`
